function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "23",
  height: "5",
  viewBox: "0 0 23 5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "20.5",
  cy: "2.5",
  r: "2.5",
  transform: "rotate(-180 20.5 2.5)",
  fill: "#B8B3C0"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "11.5",
  cy: "2.5",
  r: "2.5",
  transform: "rotate(-180 11.5 2.5)",
  fill: "#B8B3C0"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "2.5",
  cy: "2.5",
  r: "2.5",
  transform: "rotate(-180 2.5 2.5)",
  fill: "#B8B3C0"
})));